import { render, staticRenderFns } from "./vsoaExport.vue?vue&type=template&id=3cda9a10&scoped=true"
import script from "./vsoaExport.vue?vue&type=script&lang=js"
export * from "./vsoaExport.vue?vue&type=script&lang=js"
import style0 from "./vsoaExport.vue?vue&type=style&index=0&id=3cda9a10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cda9a10",
  null
  
)

export default component.exports